"use client";

import { Layout, Result } from "antd";
import AntdProvider from "@/components/providers/AntdProvider";
import I18nProvider from "@/i18n/I18nProvider";
import { DEFAULT_LOCALE, useTranslations } from "@/i18n";
import "./globals.css";

const GlobalErrorView = () => {
	const tc = useTranslations("common");
	return (
		<Layout className="min-h-screen items-center justify-center p-6">
			<Result status="error" title={tc("error")} />
		</Layout>
	);
};

/**
 * Last-resort boundary. It replaces the root layout when that layout itself
 * throws, so it brings its own <html>, theme and language providers.
 */
export default function GlobalError() {
	return (
		<html lang={DEFAULT_LOCALE}>
			<body>
				<AntdProvider>
					<I18nProvider>
						<GlobalErrorView />
					</I18nProvider>
				</AntdProvider>
			</body>
		</html>
	);
}
